<form [formGroup]="measureForm">
  <h2>Please select measure type</h2>
  <div class="form-row">
    <mat-form-field>
      <mat-label>Measure type</mat-label>
      <mat-select formControlName="type" required>
        <mat-option *ngFor="let category of categories" [value]="category">
          {{ category }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>
</form>
